import type { ReactElement } from 'react'
import React from 'react'

import { FeatureFlagDecorator } from '@components/utils/FeatureFlagDecorator'
import { Button, ModalBox } from '@fourthwall/components'

import { useAdminModeContext } from '../../../../../App/providers/AdminModeProvider'

const Wrapper = ({ children }: { children: ReactElement }) => {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: '24px' }}>{children}</div>
  )
}

export const UnavailableProductModalAlert = ({
  text,
  close,
  handleEditClick,
}: {
  text: ReactElement
  close: () => void
  handleEditClick: () => void
}) => {
  const adminMode = useAdminModeContext()

  return (
    <ModalBox
      title="Product is currently unavailable"
      buttons={[
        <FeatureFlagDecorator
          enabled={Boolean(adminMode?.isActive)}
          highlight
          description="Admin"
          spacing="large"
          wrapper={Wrapper}
        >
          <Button label="Edit Design" appearance="secondary" onClick={() => handleEditClick()} />
        </FeatureFlagDecorator>,
        <Button label="Close" appearance="primary" onClick={close} />,
      ]}
    >
      {text}
    </ModalBox>
  )
}
